module.exports = __webpack_public_path__ + "static/media/Dash1.0c4e3adc.png";